import { StudyData } from "../../../studyTable.types";
import { REPORT_TYPES } from "../../studyTableRows.consts";
import { GoogleDocController } from "./GoogleDocController";

interface DocumentsProps {
  studyData: StudyData;
  iconColourInverted: boolean;
}

export const Documents = ({ studyData, iconColourInverted }: DocumentsProps) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <GoogleDocController
        reportType={REPORT_TYPES.REFERRAL}
        studyData={studyData}
        iconColourInverted={iconColourInverted}
      />
      <GoogleDocController
        reportType={REPORT_TYPES.MEDICAL}
        studyData={studyData}
        iconColourInverted={iconColourInverted}
      />
    </div>
  );
};
